export default __webpack_public_path__ + "static/media/hand-greystone-logo.1a01a34f.png";